import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Form } from '@unform/web';
import { isEmpty, includes, isNull, isUndefined } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Select,
  Checkbox,
  Hidden,
} from '~/components/Form';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  CAUSA_MANUTENCAO_LUBRIFICANTE,
  OPERACAO_ABASTECIMENTO,
  SAFRA_ABASTECIMENTO,
  LOCALIDADE_ABASTECIMENTO,
  CUSTOMIZACAO_RAIZEN,
  MODULO_CUSTOMIZACAO_VLI,
} from '~/constants/modules';
import { t, can, canURL, validCharacters } from '~/helpers';
import api from '~/services/api';
import {
  storeData,
  updateData,
} from '~/store/modules/operacaoLubrificacao/actions';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
  toggleConfirmButton,
}) {
  const dispatch = useDispatch();

  const [habCodigoVeiculo, setHabCodigoVeiculo] = useState(true);
  const [habCodigoCentroCusto, setHabCodigoCentroCusto] = useState(true);
  const [habTotalizador, setHabTotalizador] = useState(true);
  const [habTotalizador2, setHabTotalizador2] = useState(true);

  const [habMotorista, setHabMotorista] = useState(true);
  const [habCodigoUsuario, setHabCodigoUsuario] = useState(true);

  const [
    diasliberadigitacaomovimentacaobico,
    setDiasliberadigitacaomovimentacaobico,
  ] = useState(0);

  const [posto, setPosto] = useState(0);
  const [localidadeFixa, setLocalidadeFixa] = useState(null);
  const [lubrificaoficinaposto, setLubrificaoficinaposto] = useState(null);
  const [submittedData, setSubmittedData] = useState({});
  const [veiculo, setVeiculo] = useState(null);
  const [idProduto, setIdProduto] = useState(0);
  const [custo, setCusto] = useState(null);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [totalizador2, setTotalizador2] = useState(0);
  const [empresaVeiculo, setEmpresaveiculo] = useState(null);
  const [compartments, setCompartments] = useState([]);
  const [veiculoOld, setVeiculoOld] = useState(null);
  const [idEmpresaOld, setIdEmpresaOld] = useState(null);
  const { client } = useSelector((state) => state.user.profile);
  const {
    exibeoslubrificacao,
    internounidatausuario,
    exibefrascolubrificacao,
  } = useSelector((state) => state.user.configs);
  const { loading, find, params } = useSelector(
    (state) => state.operacaoLubrificacao
  );
  const [optionsSafra, setOptionsSafra] = useState([]);

  const [optionsOperacao, setOptionsOperacao] = useState([]);
  const [idcausamanutencao, setIdcausamanutencao] = useState(0);

  const [exibeCampoMotorista, setExibeCampoMotorista] = useState(false);
  const [exibemotoristaterminal, setExibemotoristaterminal] = useState(0);
  const [
    exibemotoristaempresaveiculoLocal,
    setExibemotoristaempresaveiculoLocal,
  ] = useState(0);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const loadingErrorMessage = 's.geral.loadingerror';

  const [tipoveiculoBase, setTipoveiculoBase] = useState(null);
  const [tipoauxiliarveiculoBase, setTipoauxiliarveiculoBase] = useState(null);

  const [safraData, setSafraData] = useState({});

  const [isSafraHabilitado, setIsSafraHabilitado] = useState(false);
  const [oficina, setOficina] = useState(false);

  const initials = create ? data : { ...find, ...data };
  const formInitials = { ...initials, ...submittedData };
  const codigoAtendimentoOficina =
    formInitials.codigoatendimentooficina || formInitials.codigoatendimento;
  const oficinaDaLubrificacao = formInitials.oficinalubrificacao === 'S';

  const [temTarefaOficina, setTemTarefaOficina] = useState(false);

  useEffect(() => {
    setTemTarefaOficina(
      can(MODULO_CUSTOMIZACAO_VLI) && lubrificaoficinaposto === 'S'
    );
  }, [lubrificaoficinaposto]);

  const handleOficinaChange = (value) => {
    const valorOficina = value === 'S' ? 'S' : 'N';

    setOficina(valorOficina === 'S');
    setSubmittedData((estadoAtual) => ({
      ...estadoAtual,
      oficinalubrificacao: valorOficina,
    }));
  };

  useEffect(() => {
    setOficina(oficinaDaLubrificacao);
    reference.current?.setFieldValue(
      'oficinalubrificacao',
      oficinaDaLubrificacao ? 'S' : 'N'
    );

    if (oficinaDaLubrificacao) {
      reference.current?.setFieldValue(
        'codigoatendimentooficina',
        codigoAtendimentoOficina
      );
    }
  }, [codigoAtendimentoOficina, oficinaDaLubrificacao, reference]);

  const handleAsyncLoadingChange = useCallback(
    (isLoading) => {
      setPendingRequests((state) => {
        if (hasLoadingError) return 0;

        if (isLoading) return state + 1;

        return state > 0 ? state - 1 : 0;
      });
    },
    [hasLoadingError]
  );

  const handleAsyncLoadingError = useCallback(() => {
    setHasLoadingError(true);
    setPendingRequests(0);
  }, []);

  const handleTrackApiRequest = useCallback(
    async (request) => {
      handleAsyncLoadingChange(true);

      try {
        return await request();
      } catch (error) {
        handleAsyncLoadingError();
        throw error;
      } finally {
        handleAsyncLoadingChange(false);
      }
    },
    [handleAsyncLoadingChange, handleAsyncLoadingError]
  );

  async function handleGetVeiculo(idveiculo, empresaveiculo = undefined) {
    if (idveiculo) {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get('veiculos', {
            params: {
              wherefield: 'idveiculo',
              typewherefield: 'EQUALS',
              valuewherefield: idveiculo,
              pesquisalista: true,
            },
          })
        );

        if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
          reference.current !== null &&
            reference.current.setFieldValue('idveiculo', idveiculo);

          const {
            idempresaveiculo,
            nomeempresaveiculo,
            tipototalizadorveiculo,
            tipototalizador2veiculo,
            idcentrocusto,
            idmodeloveiculo,
            statusveiculo,
            tipoveiculo,
            tipoauxiliarveiculo,
            exibemotoristaempresaveiculo,
          } = response.data.items[0];

          setTipoveiculoBase(tipoveiculo);
          setTipoauxiliarveiculoBase(tipoauxiliarveiculo);

          if (create || (!isNull(veiculoOld) && veiculoOld !== idveiculo)) {
            setExibemotoristaempresaveiculoLocal(
              Number(exibemotoristaempresaveiculo) || 0
            );

            if (!can(CUSTOMIZACAO_RAIZEN)) {
              setEmpresaveiculo(nomeempresaveiculo);
              if (nomeempresaveiculo) {
                setEmpresaveiculo(nomeempresaveiculo);
              } else {
                setEmpresaveiculo(idempresaveiculo);
              }
            } else {
              setEmpresaveiculo(idempresaveiculo);
            }

            setTotalizador(Number(tipototalizadorveiculo) || 0);
            setTotalizador2(Number(tipototalizador2veiculo) || 0);
            await handleGetOperacoes(idmodeloveiculo);

            reference.current !== null &&
              reference.current.setFieldValue(
                'idempresaveiculo',
                idempresaveiculo
              );
          } else {
            setTotalizador(Number(tipototalizadorveiculo) || 0);
            setTotalizador2(Number(tipototalizador2veiculo) || 0);
            await handleGetOperacoes(idmodeloveiculo);

            const responseEmpresa = await handleTrackApiRequest(() =>
              api.get('empresasveiculos', {
                params: {
                  filterveic: 'false',
                  wherefield: 'idempresaveiculo',
                  typewherefield: 'EQUALS',
                  valuewherefield: !isUndefined(empresaveiculo)
                    ? empresaveiculo
                    : idempresaveiculo,
                  pesquisalista: true,
                },
              })
            );

            const { nomeempresaveiculo } = responseEmpresa.data.items[0];

            const exibemotorista =
              responseEmpresa?.data?.items?.[0]?.exibemotoristaempresaveiculo ??
              0;

            setExibemotoristaempresaveiculoLocal(exibemotorista);

            if (nomeempresaveiculo) {
              setEmpresaveiculo(nomeempresaveiculo);
            } else {
              setEmpresaveiculo(idempresaveiculo);
            }
          }

          if (can(CENTRO_CUSTO_ABASTECIMENTO) && !isEmpty(idcentrocusto)) {
            reference.current !== null &&
              reference.current.setFieldValue('idcentrocusto', idcentrocusto);

            setCusto(idcentrocusto);
          }
        } else {
          reference.current !== null &&
            reference.current.setFieldError(
              'idveiculo',
              'Veículo não encontrado!'
            );
        }
      } catch (err) {
        setOptionsOperacao([]);
      }
    }
  }

  const handleGetListaSafra = useCallback(async () => {
    try {
      const response = await handleTrackApiRequest(() =>
        api.get(`/safras`, {
          params: {
            pagesize: 99999,
            wherefield: '',
            typewherefield: '',
            valuewherefield: '',
            // orderfield: '',
            pesquisalista: true,
          },
        })
      );
      if (response.data.items.length <= 0) {
        setIsSafraHabilitado(false);
      } else {
        setIsSafraHabilitado(true);
      }
      // setOptionsSafra(
      //   response.data.items.map((i) => ({
      //     label: i.descricaosafra,
      //     value: i.idsafra,
      //   }))
      // );
    } catch (err) {
      setIsSafraHabilitado(false);
    }
  }, [handleTrackApiRequest]);

  const handleGetOperacoes = useCallback(
    async (id) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get(`/modeloveiculooperacao/operacoes/${id}`, {
            params: {
              pagesize: 99999,
              wherefield: 'statusoperacao',
              typewherefield: 'EQUALS',
              valuewherefield: 'L',
              orderfield: 'descricaooperacao',
              pesquisalista: true,
            },
          })
        );

        setOptionsOperacao(
          response.data.map((i) => ({
            label: i.descricaooperacao,
            value: i.idoperacao,
          }))
        );
      } catch (err) {
        setOptionsOperacao([]);
      }
    },
    [handleTrackApiRequest]
  );

  async function handleValidateCenterCost(cc) {
    handleAsyncLoadingChange(true);

    if (cc) {
      await setCusto(cc);

      if (cc !== '') {
        const response = await api
          .get(`centroscustos/${cc}`, { params: { pesquisalista: true } })
          .catch(async () => {
            (await (reference.current !== null)) &&
              reference.current.setFieldValue('idcentrocusto', null);
            await setCusto('');
            reference.current !== null &&
              reference.current.setFieldError(
                'idcentrocusto',
                'Centro de Custo não encontrado!'
              );
          });

        if (response && !isEmpty(response.data)) {
          const { idcentrocusto } = response.data;
          (await (reference.current !== null)) &&
            reference.current.setFieldValue('idcentrocusto', idcentrocusto);
          await setCusto(idcentrocusto);
        } else {
          (await (reference.current !== null)) &&
            reference.current.setFieldValue('idcentrocusto', null);
          await setCusto('');
        }
      } else {
        setCusto(cc);
      }
    }

    handleAsyncLoadingChange(false);
  }

  async function handleValidateMotorista() {
    handleAsyncLoadingChange(true);
    await api
      .get(`motoristas/${motorista}`, { params: { pesquisalista: true } })
      .catch(async () => {
        await reference.current.setFieldValue('idmotorista', null);
        await setCusto('');

        reference.current.setFieldError(
          'idmotorista',
          'Motorista não encontrado!'
        );
      });
    handleAsyncLoadingChange(false);
  }

  async function handleSubmit(param) {
    try {
      const allData = reference.current?.getData?.() || {};
      const objParam = { ...allData, ...param };

      if (temTarefaOficina) {
        objParam.oficinalubrificacao =
          submittedData.oficinalubrificacao || objParam.oficinalubrificacao;
      }

      if (can(LOCALIDADE_ABASTECIMENTO)) {
        objParam.idlocalidade =
          param.idlocalidade ??
          allData.idlocalidade ??
          submittedData.idlocalidade ??
          localidadeFixa;
      }

      if (hasLoadingError) {
        toast.error(t(loadingErrorMessage));
        return;
      }

      if (pendingRequests > 0) {
        toast.warning(t('s.geral.validacao.aguardecarregamento'));
        return;
      }

      setSubmittedData(objParam);

      const schema = Yup.object().shape({
        idposto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        idbico: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        // datahorainicialmovimentacao: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinalmovimentacao: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),

        datahorainicialmovimentacao: create
          ? Yup.string()
              .test(
                'campo-existe',
                t('s.geral.validacao.campoobrigatorio').replace(
                  '%s',
                  'datahorainicialmovimentacao'
                ),
                function (value) {
                  const data = this.parent;

                  if (!('datahorainicialmovimentacao' in data)) {
                    const msg = `(Data hora inicial) - ${t(
                      's.geral.validacao.campoobrigatorio'
                    ).replace('%s', 'datahorainicialmovimentacao')}`;
                    toast.error(msg);
                    return this.createError({ message: msg });
                  }

                  return true;
                }
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'min-date',
                t('s.geral.validacao.data_minima').replace(
                  '%s',
                  diasliberadigitacaomovimentacaobico
                ),
                (value) => {
                  if (!value) return true; // já tratado pelo required
                  const date = moment(value, 'DD/MM/YYYY HH:mm:ss');
                  return (
                    date.isValid() &&
                    date.isSameOrAfter(
                      moment().subtract(
                        diasliberadigitacaomovimentacaobico,
                        'days'
                      )
                    )
                  );
                }
              )
              .test('max-date', t('s.geral.validacao.data_maxima'), (value) => {
                if (!value) return true;
                const date = moment(value, 'DD/MM/YYYY HH:mm:ss');
                return date.isValid() && date.isSameOrBefore(moment());
              })
          : Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio')),
        datahorafinalmovimentacao: create
          ? Yup.string()
              .test(
                'campo-existe',
                t('s.geral.validacao.campoobrigatorio').replace(
                  '%s',
                  'datahorafinalmovimentacao'
                ),
                function (value) {
                  const data = this.parent;

                  if (!('datahorafinalmovimentacao' in data)) {
                    const msg = `(Data hora final) - ${t(
                      's.geral.validacao.campoobrigatorio'
                    ).replace('%s', 'datahorafinalmovimentacao')}`;
                    toast.error(msg);
                    return this.createError({ message: msg });
                  }

                  return true;
                }
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'after-inicial',
                t('s.geral.validacao.data_final_maior_inicial'),
                function (value) {
                  const { datahorainicialmovimentacao } = this.parent;
                  if (!value || !datahorainicialmovimentacao) return true;
                  const start = moment(
                    datahorainicialmovimentacao,
                    'DD/MM/YYYY HH:mm:ss'
                  );
                  const end = moment(value, 'DD/MM/YYYY HH:mm:ss');
                  return end.isValid() && end.isSameOrAfter(start);
                }
              )
              .test(
                'not-future',
                t('s.geral.validacao.data_final_maior_hoje'),
                (value) => {
                  if (!value) return true;
                  const end = moment(value, 'DD/MM/YYYY HH:mm:ss');
                  return end.isValid() && end.isSameOrBefore(moment()); // não permite data futura
                }
              )
          : Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio')),
        idveiculo: Yup.string()
          .trim()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),
        totalizadormovimentacaoabastecimento: includes([1, 2], totalizador)
          ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'characters-invalid',
                t('s.configuracao.geral.naopodecontercaracterespecial'),
                (value) => validCharacters(value)
              )
          : Yup.string(),
        totalizador2movimentacaoabastecimento:
          totalizador2 && includes([1, 2], totalizador2)
            ? Yup.number()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        encerranteinicialmovimentacao: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        encerrantefinalmovimentacao: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        volumemovimentacao: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .test(
            'encerrantes-volume',
            t('s.geral.validacao.valorvolumediferencaencerrantes'),
            function validateEncerrantesVolume(value) {
              const {
                encerranteinicialmovimentacao,
                encerrantefinalmovimentacao,
              } = this.parent;

              if (
                value === undefined ||
                encerranteinicialmovimentacao === undefined ||
                encerrantefinalmovimentacao === undefined
              ) {
                return true;
              }

              return (
                Math.abs(
                  Number(value) -
                    (Number(encerrantefinalmovimentacao) -
                      Number(encerranteinicialmovimentacao))
                ) <= 0.1
              );
            }
          ),
        // volumemovimentacao: Yup.number()
        //   .required(t('s.geral.validacao.campoobrigatorio'))
        //   .max(
        //     (fim - inicio + 1.0).toFixed(2), // A tolerância era 0
        //     t('s.geral.validacao.valormaximo').replace(
        //       '%s',
        //       (fim - inicio + 1.0).toFixed(2)
        //     )
        //   )
        //   .min(
        //     (fim - inicio - 1.0).toFixed(2), // A tolerância era 0
        //     t('s.geral.validacao.valorminimo').replace(
        //       '%s',
        //       (fim - inicio - 1.0).toFixed(2)
        //     )
        //   ),
        codigousuario: Yup.string()
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          )
          .required(t('s.geral.validacao.campoobrigatorio')),
        idmotorista:
          can(MOTORISTA_ABASTECIMENTO) && exibeCampoMotorista
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        idcentrocusto: can(CENTRO_CUSTO_ABASTECIMENTO)
          ? Yup.string()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
              .nullable()
          : Yup.string(),
        idlocalidade: can(LOCALIDADE_ABASTECIMENTO)
          ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string(),
        idcompartimento: Yup.string()
          .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
          .required(t('s.geral.validacao.campoobrigatorio')),
        trocalubmovimentacaolubrificacao: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        numeroosmovimentacaolubrificacao:
          exibeoslubrificacao === 0
            ? Yup.string().nullable()
            : Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        frascomovimentacaolubrificacao:
          exibefrascolubrificacao === 0
            ? Yup.number().nullable()
            : Yup.number()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0)),
        codigoatendimentooficina:
          temTarefaOficina && objParam.oficinalubrificacao === 'S'
            ? Yup.number()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .integer(t('s.geral.validacao.camponumerico'))
                .positive(t('s.geral.validacao.valorminimo').replace('%s', 1))
                .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.number().nullable(),
        idoperacao:
          can(OPERACAO_ABASTECIMENTO) && !isEmpty(optionsOperacao)
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
        idsafra:
          can(SAFRA_ABASTECIMENTO) && isSafraHabilitado
            ? Yup.number()
                .required(t('s.geral.validacao.campoobrigatorio'))
                .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
        idcausamanutencao: can(CAUSA_MANUTENCAO_LUBRIFICANTE)
          ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0))
          : Yup.number().nullable(),
      });

      await schema.validate(objParam, {
        abortEarly: false,
      });

      const {
        datahorainicialmovimentacao,
        datahorafinalmovimentacao,
      } = objParam;

      let objSend = {
        volumepredeterminadomovimentacao: '100',
        modomovimentacao: '0',
        formaidmovimentacao: '0',
        idmovimentacao: '0',
        tipomovimentacao: '0',
        numerologmovimentacao: '0',
        onlinemovimentacao: '0',
        precounitariomovimentacao: '0.0',
        vazaomediamovimentacao: '0.0',
        vazaomaximamovimentacao: '0.0',
        idcentrocusto: '',
        idcontrato: '',
        totalizadoranteriormovimentacaoabastecimento: '0.0',
        totalizador2anteriormovimentacaoabastecimento: '0.0',

        totalizadorconfirmadomovimentacaoabastecimento: '0.0',
        contingenciamovimentacaoabastecimento: '0',
        ...initials,
        ...objParam,

        datahorainicialmovimentacao,
        datahorafinalmovimentacao,
        idcliente: client,
        idoperacao: objParam.idoperacao ?? initials.idoperacao,
        idcausamanutencao:
          objParam.idcausamanutencao ?? initials.idcausamanutencao,
      };

      if (can(LOCALIDADE_ABASTECIMENTO)) {
        objSend = { ...objSend, idlocalidade: objParam.idlocalidade };
      }

      setSubmittedData(objSend);

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const getCompartiments = useCallback(
    async (vehicle, product) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get('veiculoscompartimentos', {
            params: {
              wherefield: ['idveiculo', 'idproduto'],
              typewherefield: ['EQUALS', 'EQUALS'],
              valuewherefield: [vehicle, product],
              pesquisalista: true,
            },
            paramsSerializer: (param) => qs.stringify(param),
          })
        );

        if (response.data.items) {
          setCompartments(
            response.data.items.map((i) => ({
              label: `${i.idcompartimento} - ${i.descricaocompartimento}`,
              value: i.idcompartimento,
            }))
          );
        }
      } catch (err) {
        setCompartments([]);
      }
    },
    [handleTrackApiRequest]
  );

  function atualizarExibeCampoMotorista({
    exibemotoristaterminal,
    tipoveiculoBase,
    exibemotoristaempresaveiculoLocal,
    create,
    setExibeCampoMotorista,
  }) {
    switch (exibemotoristaterminal ?? 0) {
      case 0:
        setExibeCampoMotorista(false);
        break;
      case 1:
      case 2:
        setExibeCampoMotorista(true);
        break;
      case 3:
      case 4:
        setExibeCampoMotorista(tipoveiculoBase === 0);
        break;
      case 5:
      case 6:
        setExibeCampoMotorista(tipoveiculoBase === 1);
        break;
      case 7:
      case 8:
        setExibeCampoMotorista(exibemotoristaempresaveiculoLocal > 1);
        break;
      default:
        if (!create) {
          setExibeCampoMotorista(false);
        }
    }
  }

  useEffect(() => {
    if (loading) return;

    // Define veículo inicial se necessário
    if (!create && veiculo != null) {
      initials.idveiculo = veiculo;
    }

    const formId = initials.formaidmovimentacao ?? 0;
    const podeAlterarTotalizador = internounidatausuario === 'S';

    // --- Configuração das habilitações principais ---
    const habilitacoes = {
      codigoVeiculo: false,
      codigoCentroCusto: false,
      totalizador: false,
      totalizador2: false,
      motorista: false,
      codigoUsuario: false,
    };

    const setHabilitacoes = (vals) => {
      setHabCodigoVeiculo(vals.codigoVeiculo);
      setHabCodigoCentroCusto(vals.codigoCentroCusto);
      setHabTotalizador(vals.totalizador);
      setHabTotalizador2(vals.totalizador2);
      setHabMotorista(vals.motorista);
      setHabCodigoUsuario(vals.codigoUsuario);
    };

    switch (formId) {
      case 0:
      case 106:
        setHabilitacoes({
          codigoVeiculo: true,
          codigoCentroCusto: true,
          totalizador: true,
          totalizador2: true,
          motorista: false,
          codigoUsuario: true,
        });
        break;

      case 1:
      case 4:
      case 8:
        setHabilitacoes({
          codigoVeiculo: false,
          codigoCentroCusto: true,
          totalizador: true,
          totalizador2: true,
          motorista: false,
          codigoUsuario: false,
        });
        break;

      case 2:
      case 3:
      case 6:
      case 10:
        setHabilitacoes({
          codigoVeiculo: false,
          codigoCentroCusto: true,
          totalizador: podeAlterarTotalizador,
          totalizador2: podeAlterarTotalizador,
          motorista: false,
          codigoUsuario: false,
        });
        break;

      default:
        if (!create) {
          setHabilitacoes({
            codigoVeiculo: false,
            codigoCentroCusto: false,
            totalizador: podeAlterarTotalizador,
            totalizador2: podeAlterarTotalizador,
            motorista: false,
            codigoUsuario: false,
          });
        }
    }

    // --- Atualiza exibição do motorista ---
    const atualizarMotorista = () => {
      const exibeMotorista = (valor) => {
        setHabMotorista(valor);
        setExibeCampoMotorista(valor);
      };

      const terminal = exibemotoristaterminal ?? 0;

      const deveExibirPorTipo = (tipo) =>
        (tipo === 0 && tipoveiculoBase === 0) ||
        (tipo === 1 && tipoveiculoBase === 1);

      switch (terminal) {
        case 0:
          exibeMotorista(false);
          break;
        case 1:
        case 2:
          exibeMotorista(true);
          break;
        case 3:
        case 4:
          exibeMotorista(deveExibirPorTipo(0));
          break;
        case 5:
        case 6:
          exibeMotorista(deveExibirPorTipo(1));
          break;
        case 7:
        case 8:
          exibeMotorista(exibemotoristaempresaveiculoLocal > 1);
          break;
        default:
          if (!create) exibeMotorista(false);
      }
    };

    if (!create) {
      atualizarMotorista();
    } else if (can(MOTORISTA_ABASTECIMENTO)) {
      atualizarMotorista();
    }
  }, [
    loading,
    create,
    veiculo,
    initials,
    internounidatausuario,
    exibemotoristaterminal,
    tipoveiculoBase,
    exibemotoristaempresaveiculoLocal,
  ]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      const {
        totalizadormovimentacaoabastecimento,

        totalizador2movimentacaoabastecimento,

        encerranteinicialmovimentacao,
        encerrantefinalmovimentacao,
        volumemovimentacao,
        idveiculo,
        idproduto,
        idempresaveiculo,
      } = find;

      if (!create) {
        setTotalizador(Number(totalizadormovimentacaoabastecimento > 0));

        setTotalizador2(Number(totalizador2movimentacaoabastecimento > 0));

        if (idempresaveiculo) {
          setIdEmpresaOld(idempresaveiculo || 0);
        }

        if (idveiculo) {
          setVeiculoOld(idveiculo || 0);
          setVeiculo(idveiculo || 0);
          handleGetVeiculo(idveiculo, idempresaveiculo);
        }

        if (idveiculo && idproduto) getCompartiments(idveiculo, idproduto);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  useEffect(() => {
    if (veiculo && idProduto) {
      getCompartiments(veiculo, idProduto);
    }
  }, [veiculo, idProduto]);

  useEffect(() => {
    if (can(SAFRA_ABASTECIMENTO)) {
      handleGetListaSafra();
    }
  }, [handleGetListaSafra]);

  useEffect(() => {
    toggleLoading(pendingRequests > 0);
  }, [pendingRequests, toggleLoading]);

  useEffect(() => {
    toggleConfirmButton(!hasLoadingError);
  }, [hasLoadingError, toggleConfirmButton]);

  useEffect(
    () => () => {
      toggleLoading(false);
      toggleConfirmButton(true);
    },
    [toggleLoading, toggleConfirmButton]
  );

  const handleValidateInputVehicle = useCallback(async () => {
    await reference.current.setFieldValue('idoperacao', '');

    if (veiculo) {
      await handleGetVeiculo(veiculo, idEmpresaOld);
    }
  }, [veiculo, veiculoOld, idEmpresaOld]);

  const handleChangepostoscomboios = React.useCallback((value) => {
    if (value.idposto) {
      setPosto(value.idposto);
      setLocalidadeFixa(
        Number(value.idlocalidade) > 0 ? Number(value.idlocalidade) : null
      );
      setLubrificaoficinaposto(value.lubrificaoficinaposto);
    } else {
      setPosto(null);
      setLocalidadeFixa(null);
      setLubrificaoficinaposto(null);
    }
    // setDiasliberadigitacaomovimentacaobico(-2)
  }, []);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : hasLoadingError ? (
        <div
          style={{
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            padding: '16px',
            lineHeight: 1.5,
          }}
        >
          {t(loadingErrorMessage)}
        </div>
      ) : (
        <div style={{ position: 'relative', minHeight: '14rem' }}>
          <Form
            ref={reference}
            initialData={formInitials}
            onSubmit={handleSubmit}
          >
            {/* <h1>{JSON.stringify(diasliberadigitacaomovimentacaobico)}</h1> */}
            <Hidden name="idatendimento" />

            <Autocomplete
              name="idposto"
              disabled={!create}
              disableClearable={!create}
              label="nomeposto"
              url="postoscomboios"
              unique="idposto"
              title={t('s.menu.configuracao.posto')}
              getValue={(value) => {
                handleChangepostoscomboios(value);
                // if (value.idposto) {
                //   setPosto(value.idposto);
                // } else {
                //   setPosto(0);
                // }
              }}
              onLoadingChange={handleAsyncLoadingChange}
              onLoadingError={handleAsyncLoadingError}
            />

            {create ? (
              posto ? (
                <Combobox
                  name="idbico"
                  disabled={!create || posto === 0}
                  label="bicoprodutobico"
                  url="bicos"
                  unique="idbico"
                  title={t('s.menu.configuracao.bico')}
                  hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                  params={{
                    wherefield: !create
                      ? ['idposto', 'tipoproduto']
                      : [
                          'idposto',
                          'tipoproduto',
                          'bloqueiadigitacaomovimentacaobico',
                        ],
                    valuewherefield: !create
                      ? [!isEmpty(find) ? find.idposto : posto, 'L']
                      : [!isEmpty(find) ? find.idposto : posto, 'L', 'S'],
                    typewherefield: !create
                      ? ['EQUALS', 'EQUALS']
                      : ['EQUALS', 'EQUALS', 'EQUALS'],
                    fieldlist:
                      'idbico, idterminal, idproduto, bicoprodutobico, exibemotoristaterminal, diasliberadigitacaomovimentacaobico',
                  }}
                  getValue={(value) => {
                    value.idproduto && setIdProduto(value.idproduto);

                    if (value?.exibemotoristaterminal) {
                      setExibemotoristaterminal(value?.exibemotoristaterminal);
                    } else {
                      setExibemotoristaterminal(0);
                    }

                    if (value?.diasliberadigitacaomovimentacaobico) {
                      setDiasliberadigitacaomovimentacaobico(
                        value?.diasliberadigitacaomovimentacaobico
                      );
                    } else {
                      setDiasliberadigitacaomovimentacaobico(0);
                    }
                  }}
                  onLoadingChange={handleAsyncLoadingChange}
                  onLoadingError={handleAsyncLoadingError}
                />
              ) : (
                <></>
              )
            ) : (
              <Combobox
                name="idbico"
                disabled={!create || posto === 0}
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: !create
                    ? ['idposto', 'tipoproduto']
                    : [
                        'idposto',
                        'tipoproduto',
                        'bloqueiadigitacaomovimentacaobico',
                      ],
                  valuewherefield: !create
                    ? [!isEmpty(find) ? find.idposto : posto, 'L']
                    : [!isEmpty(find) ? find.idposto : posto, 'L', 'S'],
                  typewherefield: !create
                    ? ['EQUALS', 'EQUALS']
                    : ['EQUALS', 'EQUALS', 'EQUALS'],
                  fieldlist:
                    'idbico, idterminal, idproduto, bicoprodutobico, exibemotoristaterminal, diasliberadigitacaomovimentacaobico',
                }}
                getValue={(value) => {
                  value.idproduto && setIdProduto(value.idproduto);

                  if (value?.exibemotoristaterminal) {
                    setExibemotoristaterminal(value?.exibemotoristaterminal);
                  } else {
                    setExibemotoristaterminal(0);
                  }

                  if (value?.diasliberadigitacaomovimentacaobico) {
                    setDiasliberadigitacaomovimentacaobico(
                      value?.diasliberadigitacaomovimentacaobico
                    );
                  } else {
                    setDiasliberadigitacaomovimentacaobico(0);
                  }
                }}
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            {create ? (
              posto && Number(diasliberadigitacaomovimentacaobico) > 0 ? (
                <>
                  <DateTime
                    time
                    name="datahorainicialmovimentacao"
                    disabled={!create}
                    label={t(
                      's.operacao.abastecimento.datahorainicialmovimentacao'
                    )}
                    minDate={moment().subtract(
                      Number(diasliberadigitacaomovimentacaobico),
                      'days'
                    )} // ex: permite no máximo 7 dias atrás
                    maxDate={moment()}
                    shouldDisableDate={(day) =>
                      day.isBefore(
                        moment().subtract(
                          Number(diasliberadigitacaomovimentacaobico),
                          'days'
                        )
                      )
                    }
                    disableMaskedInput
                    helperText=""
                  />

                  <DateTime
                    time
                    name="datahorafinalmovimentacao"
                    disabled={!create}
                    label={t(
                      's.operacao.abastecimento.datahorafinalmovimentacao'
                    )}
                    minDate={moment().subtract(
                      Number(diasliberadigitacaomovimentacaobico),
                      'days'
                    )} // ex: permite no máximo 7 dias atrás
                    maxDate={moment()}
                    shouldDisableDate={(day) =>
                      day.isBefore(
                        moment().subtract(
                          Number(diasliberadigitacaomovimentacaobico),
                          'days'
                        )
                      )
                    }
                    disableMaskedInput
                    helperText=""
                  />
                </>
              ) : (
                <></>
              )
            ) : (
              <>
                <DateTime
                  time
                  name="datahorainicialmovimentacao"
                  disabled={!create}
                  label={t(
                    's.operacao.abastecimento.datahorainicialmovimentacao'
                  )}
                />

                <DateTime
                  time
                  name="datahorafinalmovimentacao"
                  disabled={!create}
                  label={t(
                    's.operacao.abastecimento.datahorafinalmovimentacao'
                  )}
                />
              </>
            )}

            {/* <DateTime
            time
            name="datahorainicialmovimentacao"
            disabled={!create}
            label={t('s.operacao.abastecimento.datahorainicialmovimentacao')}
          />

          <DateTime
            time
            name="datahorafinalmovimentacao"
            disabled={!create}
            label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
          /> */}

            <Input
              name="idveiculo"
              disabled={!habCodigoVeiculo}
              onInputChange={(event, newValue) => {
                setVeiculo(newValue);
              }}
              onChange={(event) => setVeiculo(event.target.value)}
              label={t('s.operacao.abastecimento.idveiculo')}
              onKeyUp={({ key }) =>
                key === 'Enter' && handleValidateInputVehicle()
              }
              getValue={(value) => setVeiculo(value)}
              onBlur={() => handleValidateInputVehicle()}
            />

            <Input
              name="idempresaveiculo"
              label={t('s.operacao.abastecimento.idempresaveiculo')}
              value={empresaVeiculo}
              disabled
            />

            {can(CENTRO_CUSTO_ABASTECIMENTO) && (
              <Input
                name="idcentrocusto"
                disabled={!habCodigoCentroCusto}
                label={t('s.operacao.abastecimento.idcentrocusto')}
                value={custo}
                getValue={(value) => setCusto(value)}
                onInputChange={(event, newValue) => {
                  setCusto(newValue);
                }}
                onBlur={(event) => {
                  handleValidateCenterCost(event.target.value);
                }}
              />
            )}

            {can(LOCALIDADE_ABASTECIMENTO) && (
              <Autocomplete
                name="idlocalidade"
                label="nomelocalidade"
                url="localidades"
                unique="idlocalidade"
                title="Localidade"
                disabled={create && Number(localidadeFixa) > 0}
                forcedValue={
                  create && Number(localidadeFixa) > 0
                    ? localidadeFixa
                    : undefined
                }
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            <Input
              name="totalizadormovimentacaoabastecimento"
              disabled={!habTotalizador}
              label={t(
                `s.operacao.abastecimento.${
                  totalizador === 1 ? 'horimetro' : 'hodometro'
                }`
              )}
              style={{
                display: includes([1, 2], totalizador) ? 'block' : 'none',
              }}
              type="number"
            />

            {habTotalizador2 && (
              <Input
                name="totalizador2movimentacaoabastecimento"
                type="number"
                disabled={!habTotalizador2}
                label={t(
                  `s.operacao.abastecimento.${
                    totalizador2 === 1 ? 'horimetro' : 'hodometro'
                  }`
                )}
                style={{
                  display: includes([1, 2], totalizador2) ? 'block' : 'none',
                }}
              />
            )}

            <Input
              name="encerranteinicialmovimentacao"
              disabled={!create && !canURL().altera_encerrante}
              label={t(
                's.operacao.abastecimento.encerranteinicialmovimentacao'
              )}
              type="number"
            />

            <Input
              name="encerrantefinalmovimentacao"
              disabled={!create && !canURL().altera_encerrante}
              label={t('s.operacao.abastecimento.encerrantefinalmovimentacao')}
              type="number"
            />

            <Input
              name="volumemovimentacao"
              disabled={!create}
              label={t('s.operacao.abastecimento.volumemovimentacao')}
              type="number"
            />

            <Input
              name="codigousuario"
              disabled={!habCodigoUsuario}
              label={t('s.operacao.abastecimento.codigousuario')}
            />

            {can(MOTORISTA_ABASTECIMENTO) && exibeCampoMotorista && (
              <Input
                name="idmotorista"
                disabled={!habMotorista}
                label={t('s.operacao.abastecimento.idmotorista')}
                value={motorista}
                getValue={(value) => setMotorista(value)}
                onBlur={() => handleValidateMotorista()}
                onKeyUp={({ key }) =>
                  key === 'Enter' && handleValidateMotorista()
                }
              />
            )}
            {/*
          {((!can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista))
            || (can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista))) && (
              // {can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista) && (
              // {can(MOTORISTA_ABASTECIMENTO) && (exibemotoristaterminal > 0) && (
              <Input
                name="idmotorista"
                disabled={!habMotorista}
                label={t('s.operacao.abastecimento.idmotorista')}
                value={motorista}
                getValue={(value) => setMotorista(value)}
                onBlur={() => handleValidateMotorista()}
                onKeyUp={({ key }) =>
                  key === 'Enter' && handleValidateMotorista()
                }
              />
            )} */}

            <Select
              name="idcompartimento"
              label={t('s.operacao.lubrificacao.idcompartimento')}
              options={compartments}
              disabled={!habCodigoVeiculo}
            />

            <Select
              name="trocalubmovimentacaolubrificacao"
              label={t(
                's.operacao.lubrificacao.trocalubmovimentacaolubrificacao'
              )}
              options={[
                { label: t('s.geral.opcoes.nao'), value: 0 },
                { label: t('s.geral.opcoes.sim'), value: 1 },
              ]}
            />

            {temTarefaOficina && (
              <>
                <Checkbox
                  name="oficinalubrificacao"
                  label={t('s.geral.oficina')}
                  serialize={(value) => (value ? 'S' : 'N')}
                  getValue={handleOficinaChange}
                  disabled={!create}
                />
                {oficina && (
                  <Input
                    name="codigoatendimentooficina"
                    label="CO"
                    type="number"
                    disabled={!create}
                  />
                )}
              </>
            )}

            {exibeoslubrificacao === 1 && (
              <Input
                name="numeroosmovimentacaolubrificacao"
                label={t(
                  's.operacao.lubrificacao.numeroosmovimentacaolubrificacao'
                )}
              />
            )}

            {exibefrascolubrificacao === 1 && (
              <Input
                name="frascomovimentacaolubrificacao"
                label={t('s.geral.camposistema.frascomovimentacaolubrificacao')}
                type="number"
              />
            )}

            {can(SAFRA_ABASTECIMENTO) && (
              <Autocomplete
                name="idsafra"
                title={t('s.geral.camposistema.idsafra')}
                url="safras"
                unique="idsafra"
                label="descricaosafra"
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            {can(OPERACAO_ABASTECIMENTO) && (
              <Select
                name="idoperacao"
                label={t('s.menu.cadastro.operacao')}
                options={optionsOperacao}
              />
            )}

            {can(CAUSA_MANUTENCAO_LUBRIFICANTE) && (
              <Autocomplete
                name="idcausamanutencao"
                label="descricaocausamanutencao"
                url="causasmanutencoes"
                unique="idcausamanutencao"
                title={t('s.menu.cadastro.causamanutencao')}
                params={{
                  orderfield: 'descricaocausamanutencao',
                  wherefield: 'statuscausamanutencao',
                  valuewherefield: 'L',
                  typewherefield: 'EQUALS',
                }}
                getValue={(value) => {
                  if (value.idcausamanutencao) {
                    setIdcausamanutencao(value.idcausamanutencao);
                  }
                }}
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}
          </Form>
          <Spinner loading={pendingRequests > 0} />
        </div>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  toggleLoading: PropTypes.func,
  toggleConfirmButton: PropTypes.func,
};

CreateOrUpdate.defaultProps = {
  data: {},
  toggleLoading: () => {},
  toggleConfirmButton: () => {},
};
